import Quill from 'quill';
import quillConfig from './quill-config';

/**
 * Initialise Quill for every matching editor element on the page.
 * Each editor element must have a sibling textarea with an id of
 * `{editorId}-input` where `editorId` is the id of the editor div.
 *
 * @param {string} selector - CSS selector for editor container elements
 */
export function initQuillFields(selector = '[data-quill-editor]') {
    document.querySelectorAll(selector).forEach((editorEl) => {
        const inputId = editorEl.dataset.quillInput;
        const input = document.getElementById(inputId);
        if (!input) return;

        const quill = new Quill(editorEl, quillConfig);

        if (input.value.trim()) {
            quill.root.innerHTML = input.value;
        }

        input.closest('form').addEventListener('submit', function () {
            input.value = quill.root.innerHTML;
        });
    });
}
